import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar/navbar.js";
import RafflePrizeWidget from "./Components/RafflePrizeWidget/RafflePrizeWidget";
import Home from "./Pages/Home/Home.js";
import AmountRaised from "./Pages/AmountRaised/AmountRaised.js";
import Footer from "./Components/Footer/Footer.js";
import Gallery from "./Pages/Gallery/Gallery.js";
import Ourstory from "./Pages/Our-Story/OurStory.js";
import STGilesDonate from "./Pages/Donate-stgiles/Donate.js";
import MatchInfo from "./Pages/MatchInfo/MatchInfo.js";
import Media from "./Pages/Media/Media.js";
import usePageTracker from "./Components/StatTracker.js";
import Login from "./Admin/Login/Login.js";
import ScrollManager from "./Components/ScrollManager.js";
import WoodenSpoonDonate from "./Pages/Donate-woodenspoon/Donate.js";
import SupporterUpload from "./Pages/Image Upload/UploadImage.js";
import { useConfig } from "./context/ConfigContext";
import AdminSetup from "./Admin/Admin-Setup/Admin-Setup.js";
import Auctions from "./Pages/Auctions/Auctions.js";

import Policies from "./Pages/Policies/Policies.js";

function Tracker() {
  usePageTracker();
  return null;
}

export default function App() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("bbmm_theme") || "dark"
  );

  const { config, loading, error } = useConfig();

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("bbmm_theme", theme);
  }, [theme]);

  if (loading || !config) {
    return (
      <div className="app loading-screen">
        <div className="loading-content">
          <h1>Loading...</h1>
          <p>Fetching configuration…</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app error-screen">
        <div className="error-content">
          <h1>Something went wrong</h1>
          <p>Unable to load site configuration. Please try again later.</p>
        </div>
      </div>
    );
  }

  const ExternalRedirect = ({ url }) => {
    window.location.replace(url);
    return null;
  };

  return (
    <Router>
      <Tracker />
      <ScrollManager />
      <div className="app">
        <Navbar theme={theme} setTheme={setTheme} />
        <RafflePrizeWidget />
        <main className="container">
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/amount-raised" element={<AmountRaised />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Login />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/our-story" element={<Ourstory />} />
            <Route path="/stgilesdonate" element={<STGilesDonate />} />
            <Route path="/match-info" element={<MatchInfo />} />
            <Route path="/media" element={<Media />} />
            <Route path="/woodenspoondonate" element={<WoodenSpoonDonate />} />
            <Route path="/upload-images" element={<SupporterUpload />} />
            <Route path="/admin-setup" element={<AdminSetup />} />
            <Route path="/allauctions" element={<Auctions />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
            
            <Route path="/policies" element={<Policies />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
